import React, { useEffect, useState, useContext } from "react";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import formatDate from "../../tools/FormatDate";
import APP from "../../tools/AppRoutes";
import LabelCS from "../../components/LabelCS"
import BotonCS from "../../components/BotonCS";
import TextFieldCS from "../../components/TextFieldCS";
import enviarPeticion from "../../tools/EnviarPeticion";
import { Helmet } from "react-helmet-async";
import { CircularProgress } from "@mui/material";
import Context from "../Master/SessionProvider";
import { HISTORIAL, CONFIGURAR, ALTA, INTELISIS } from "../../tools/ApiRoutes";
import Alert from "../../components/Alert";
import DropDownListCS from "../../components/DropDownListCS";
import ModalCS from "../../components/ModalCS";
import ObtenerToken from "../../tools/ObtenerToken";

const DetalleAlta = ({history}) => {
    const { user, selected, menu, marcarMenu } = useContext(Context);

    const [ modificar, setModificar ] = useState(selected);
    const [ loading, setLoading ] = useState(true);
    const [ revisar, setRevisar ] = useState({});
    const [ listaRegimen, setListaRegimen ] = useState([]);
    const [ configuracion, setConfiguracion ] = useState();
    const [ showRevisar, setShowRevisar ] = useState({Estatus: '', Show: false});
    const [ showRevisado, setShowRevisado ] = useState({Estatus: '', Show: false});
    const [ alert , setAlert ] = useState({ msg: '', severity: 'success', open: false }); //MODAL NOTIFICACIONES


    //ESTO ES LO QUE SE MUESTRA AL ELEGIR LA CONFIGURACIÓN
    const obtenerConfig = () => {
        if (configuracion !== '' && configuracion !== undefined && configuracion !== null){
            return `Códigos ${configuracion.CodigosResponsabilidades} - Régimen Intelisis ${configuracion.RegimenIntelisis} - Autoretenedor ${configuracion.Autoretenedor === true ? 'Sí' : 'No'} - Retenedor IVA ${configuracion.RetenedorIVA === true ? 'Sí' : 'No'}`;
        }else{
            return '';
        }
    }
    const configSel = obtenerConfig();

    const obtenerCodigos = () => {

        if (modificar.Codigos !== null  && modificar.Codigos !== undefined && modificar.Codigos !== ""){
            
            const array = modificar.Codigos.split(';');
            let nuevoArray = "";

            array.forEach(element => {

                nuevoArray += `${element.replace("O-","").padStart(2,'0')}-`;
            });

            return nuevoArray.substring(0,nuevoArray.length-1);
        }
        else{
            return "";
        }
    }
    const codigos = obtenerCodigos();

    const validarDescripcion = () => {
        if (modificar.CodigoCIIUActividadSecundaria !== "" && modificar.FechaInicioActividadSec !== "" && modificar.FechaInicioActividadSec !== null)
        return false;
    else return true;
    }
    const segundaDescripcion = validarDescripcion();

    const obtenerConfiguracion = (list,codigos) => {
        const lista =[ ...list]; //HACEMOS UNA COPIA PARA NO ALTERAR EL ORIGINAL
        lista.shift();

        let resultado = "Por Definir";

        if ((lista !== null && lista !== undefined && lista.length > 0) && (codigos !== null && codigos !== undefined && codigos !== "")){

            //PRIMERO ORDENAMOS LA LISTA POR CÓDIGOS Y ALFABÉTICAMENTE
            lista.sort((a,b) => {
                if (a.CodigosResponsabilidades.length === b.CodigosResponsabilidades.length){
                    return a.CodigosResponsabilidades.localeCompare(b.CodigosResponsabilidades);
                }

                return  b.CodigosResponsabilidades.length - a.CodigosResponsabilidades.length;
            });

            const codes = `${codigos}-` //ASÍ CADA CÓDIGO ES, EJEMPLO: 05-, 07-, 47-

            //RECORREMOS CADA CONFIGURACIÓN EN BUSCA DE LA MEJOR COINCIDENCIA
            lista.forEach(element => {

                //TOMAMOS LOS CÓDIGOS DE LA CONFIGURACIÓN Y LOS SEPARAMOS POR -
                const array = element.CodigosResponsabilidades.split('-');

                //PREDETERMINADO ES TRUE, A MENOS QUE UN CÓDIGO NO COINCIDA
                let valido = true;

                //RECORREMOS TODO, CUANDO COINCIDAN TODO SE MANTIENE EN TRUE Y GUARDA EL NOMBRE
                array.forEach(n => {

                    //SI NO ENCUENTRA ALGÚN CÓDIGO
                    if(codes.includes(`${n}-`) === false){
                        valido = false;
                    }
                });

                //SI ENCUNTRA TODOS REGRESAMOS ESA CONFIGURACIÓN
                if (valido === true){

                    //SI ES EL VALOR INICIAL ASIGNAMOS UN NUEVO VALOR, ASÍ NOS QUEDAMOS CON EL PRIMERO QUE ENCUENTRE
                    if (resultado === "Por Definir") resultado = element.NombreRegimen;
                }
                
            });

            //SI LLEGA HASTA AQUÍ ES PORQUE NINGUNO COINCIDIÓ
            return resultado;
        }
        else return resultado;
    }
    const config = obtenerConfiguracion(listaRegimen, codigos);

    const descargar = (prop) => {
        let ruta = "";
        
        switch (prop){
            case "ccc": ruta = modificar.CertificadoCamaraComer;
            break;
            case "rut": ruta = modificar.Rut;
            break;
            case "rc1": ruta = modificar.CartaReferencia1;
            break;
            case "rc2": ruta = modificar.CartaReferencia2;
            break;
            case "irl": ruta = modificar.IdentificacionRepLegal;
            break
        }
        
        const indiceInicial = ruta.lastIndexOf('\\');
        const indiceFinal = ruta.length;
        const nombre = ruta.slice(indiceInicial+1, indiceFinal);

        const data = {
            Ruta: ruta
        }

        const config = {
            method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data),
                responseType: 'blob'
        };

        fetch(HISTORIAL.DescargarArchivo, config)
        .then(response => response.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nombre;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => console.log(error));
    }

    const llenarListaRegimen = async () => {
        const data = {
            Estatus: "1"
        };

        const config = {
            method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data)
        };

        const res = await enviarPeticion(config, CONFIGURAR.ListaRegimenes);
        const nuevo = {NombreRegimen: "Selecciona una opción"};
        const nuevoRes = [nuevo, ...res.data];

        setListaRegimen(nuevoRes);

        return nuevoRes;
    }

    const validaciones = () => {

        const vacio = (toValid) => {
            const valor = toValid === undefined || toValid === null ? "" : toValid.toString();
            return valor === "" || valor.trim() === "" ? true : false;
        }

        //VERIFICAMOS CADA CAMPO DE FORMA PARTICULAR
        if(vacio(modificar.Direccion) === true){
            setAlert({msg: 'Ingresa la Dirección', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.CP) === true || /[0-9]/.test(modificar.CP) === false){
            setAlert({msg: 'Ingresa un Código Postal Válido', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.Telefono) === true || /[0-9]/.test(modificar.Telefono) === false){
            setAlert({msg: 'Ingresa el Teléfono de la Empresa', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.Municipio) === true){
            setAlert({msg: 'Ingresa el Municipio', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.Departamento) === true){
            setAlert({msg: 'Ingresa el Departamento', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.RepresentanteLegal) === true){
            setAlert({msg: 'Ingresa el Representante Legal', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.TipoDocumento) === true || modificar.TipoDocumento === "Selecciona una opción"){
            setAlert({msg: 'Elige un tipo de documento de identificación', severity: "warning", open: true });
            return false;
        }

        if(vacio(modificar.NumeroIdentificacion) === true || /[0-9]/.test(modificar.NumeroIdentificacion) === false){
            setAlert({msg: 'Ingresa el Número de Identificación', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.CodigoCIIUActividadPrimaria) === false && vacio(modificar.FechaInicioActividad) === false){
            if (vacio(modificar.ActividadPrincipalDes) === true){
                setAlert({msg: 'Describe la actividad principal', severity: "warning", open: true });
                return false;
            }
        }

        if (vacio(modificar.CodigoCIIUActividadSecundaria) === false && vacio(modificar.FechaInicioActividadSec) === false){
            if (vacio(modificar.ActividadSecundariaDes) === true){
                setAlert({msg: 'Describe la actividad secundaria', severity: "warning", open: true });
                return false;
            }
        }

        if (vacio(modificar.ActividadEconomicaMayorRiesgo) === true || /[0-9]/.test(modificar.ActividadEconomicaMayorRiesgo) === false){
            setAlert({msg: 'Escribe la actividad de mayor riesgo', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.NombreSolicitante) === true){
            setAlert({msg: 'Escribe el nombre del contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.CargoDeSolicitante) === true){
            setAlert({msg: 'Escribe el cargo del contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.EmailSolicitante) === true || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(modificar.EmailSolicitante) === false){
            setAlert({msg: 'Escribe un correo válido para el contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.TelefonoSolicitante) === true || /[0-9]/.test(modificar.TelefonoSolicitante) === false){
            setAlert({msg: 'Escribe el teléfono del contacto comercial', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.ContactoAdministrativoNombre) === true){
            setAlert({msg: 'Escribe el nombre del contacto administrativo', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.ContactoAdministrativoEmail) === true || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(modificar.ContactoAdministrativoEmail) === false){
            setAlert({msg: 'Escribe un correo válido para el contacto administrativo', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.ContactoAdministrativoTelefono) === true || /[0-9]/.test(modificar.ContactoAdministrativoTelefono) === false){
            setAlert({msg: 'Escribe el teléfono del contacto administrativo', severity: "warning", open: true });
            return false;
        }

        if (vacio(modificar.DondeConocioCompuSoluciones) === true){
            setAlert({msg: 'Escribe quién te contactó', severity: "warning", open: true });
            return false;
        }

        if (vacio(revisar.Comentarios) === true){
            setAlert({ msg: 'Escribe al menos un comentario para Autorizar', severity: 'warning', open: true });
            return false;
        }

        if (vacio(revisar.Regimen) === true || revisar.Regimen === "Selecciona una opción"){
            setAlert({ msg: 'Elige el Régimen que se le asignará en Intelisis', severity: 'warning', open: true });
            return false;
        }

        //SI LLEGA HASTA AQUÍ REGRESAMOS TRUE
        return true;
    }

    const handleModificar = (prop) => (event) => {
        setModificar({...modificar, [prop]: event.target.value});
    }

    const handleRevisar = (prop) => (event) => {

        //SI ELIGEN LA LISTA DE REGÍMENES MOSTRAMOS LA CONFIGURACIÓN
        if (prop === "Regimen" && event.target.value !== "Selecciona una opción"){

            const filtro = listaRegimen.filter(row => row.NombreRegimen === event.target.value);

            //VALIDAMOS QUE EL RÉGIMEN LO HAYAN CONFIGURADO BIEN
            if (filtro[0].RegimenIntelisis !== null && filtro[0].Autoretenedor !== null && filtro[0].RetenedorIVA !== null){
                setConfiguracion(filtro[0]);
                setRevisar({...revisar, [prop]: event.target.value});

            }
            else{
                setAlert({ msg: `El régimen ${event.target.value} no ha sido configurado`, severity: 'error', open: true });
            }

            
        } else if (event.target.value === "Selecciona una opción"){
            setAlert({ msg: `Elige una configuración válida`, severity: 'warning', open: true });
        }
        else{
            setRevisar({...revisar, [prop]: event.target.value});
        }
    }

    const clickRevisar = (prop) => {
        //SI AUTORIZAN LA SOLICITUD REVISAMOS LOS CAMPOS
        if (prop === "Autorizar"){
            const validar = validaciones();

            if (validar === true){
                setShowRevisar({Estatus: prop, Show: true});
            }
        }
        else{
            if (revisar.Comentarios === null || revisar.Comentarios === undefined || revisar.Comentarios === ""){
                setAlert({ msg: 'Escribe al menos un comentario para Rechazar', severity: 'warning', open: true });
            }
            else{
                setShowRevisar({Estatus: prop, Show: true});
            }
        }
    }

    const cerrarRevisar = () => {
        setShowRevisar(false);
    }

    const regresarHistorial = () => {
        window.scrollTo(0,0);
        const pathname = `#${APP.HISTORIAL}`;
        marcarMenu({...menu, pathname });
        history.push(APP.HISTORIAL);
    }

    const obtenerArchivos = () => {
        let array = [];

        //REVISAMOS CADA ARCHIVO
        if (selected.CertificadoCamaraComer !== undefined && selected.CertificadoCamaraComer !== null && selected.CertificadoCamaraComer !== ""){
            array.push(selected.CertificadoCamaraComer);
        }

        if (selected.Rut !== undefined && selected.Rut !== null && selected.Rut !== ""){
            array.push(selected.Rut);
        }

        if (selected.CartaReferencia1 !== undefined && selected.CartaReferencia1 !== null && selected.CartaReferencia1 !== ""){
            array.push(selected.CartaReferencia1);
        }

        if (selected.CartaReferencia2 !== undefined && selected.CartaReferencia2 !== null && selected.CartaReferencia2 !== ""){
            array.push(selected.CartaReferencia2);
        }

        if (selected.IdentificacionRepLegal !== undefined && selected.IdentificacionRepLegal !== null && selected.IdentificacionRepLegal !== ""){
            array.push(selected.IdentificacionRepLegal);
        }

        return array;

    }

    const altaIntelisis = async() => {
        const token = await ObtenerToken();

        const identificacion = modificar.TipoContribuyente === "Persona jurídica" ? "31" : "13";

        const data = {
            Tipo: "Cliente",
            Estatus: "ALTA",
            Nombre: modificar.RazonSocial,
            Grado: "DISTRIBUID",
            Grupo: "Select",
            Telefonos: modificar.Telefono,
            Contacto1: modificar.NombreSolicitante,
            eMail1: modificar.EmailSolicitante,
            Direccion: modificar.Direccion,
            CodigoPostal: modificar.CP,
            Poblacion: modificar.Municipio,
            Delegacion: modificar.Municipio,
            Estado: modificar.Departamento,
            Pais: "Colombia",
            Cuenta: "13050501",
            TipoDeIdentificacion: identificacion,
            RFC: `${modificar.NIT}`,
            DigitoVerificador: `${modificar.DV}`,                                                                                                                       
            FECodRegimenFiscal: "48",
            FECodigosResponsabilidades: modificar.Codigos,
            FiscalRegimen: configuracion.RegimenIntelisis,
            fiscalRetieneIsr: configuracion.Autoretenedor,
            fiscalRetieneIva: configuracion.RetenedorIVA,
            Condicion: "CONTADO",
            Credito: "CONTADO",
            CreditoEspecial: false,
            CreditoConLimite: false,
            CreditoConLimitePedidos: false
        };

        const config = {
            method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token.data.token}`
                },
                body: JSON.stringify(data)
        };

        const res = await enviarPeticion(config, INTELISIS.RegistrarIntelisis);

        return res;
    }

    const anexoIntelisis = async(numero) => {

        const listaArchivos = obtenerArchivos();

        const token = await ObtenerToken();

        //AGREGAMOS CADA UNO DE LOS ARCHIVOS
        listaArchivos.forEach((item) => {

            const data = {
                cuenta: numero,
                tipo: "Archivo",
                direccion: item
            };
    
            const config = {
                method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token.data.token}`
                    },
                    body: JSON.stringify(data)
            };
    
            enviarPeticion(config, INTELISIS.RegistrarAnexo);
        });   
    }

    const actualizarRegistro = async(numero) => {
        const data = {
            IdRegistro: modificar.IdRegistro,
            Estatus: showRevisar.Estatus,
            Usuario: user.Usuario,
            Comentarios: revisar.Comentarios,
            NumeroCliente: numero
        };

        const config = {
            method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data)
        };

        const res = await enviarPeticion(config, ALTA.Revisar);

        return res;
    }

    const guardarAlta = async(numero) => {
        const data = {
            IdSolicitud: modificar.IdRegistro,
            RazonSocial: modificar.RazonSocial,
            NIT: modificar.NIT,
            DV: modificar.DV,
            Direccion: modificar.Direccion,
            Telefono: modificar.Telefono,
            CodigoPostal: modificar.CP,
            Municipio: modificar.Municipio,
            Departamento: modificar.Departamento,
            RepresentanteLegal: modificar.RepresentanteLegal,
            TipoDocumento: modificar.TipoDocumento,
            NumeroIdentificacion: modificar.NumeroIdentificacion,
            Correo: modificar.EmailSolicitante,
            ActividadEconomica1: modificar.CodigoCIIUActividadPrimaria,
            ActividadPrincipalDes: modificar.ActividadPrincipalDes,
            InicioActividad1: modificar.FechaInicioActividad,
            ActividadEconomica2: modificar.CodigoCIIUActividadSecundaria ?? '',
            ActividadSecundariaDes: modificar.ActividadSecundariaDes ?? '',
            InicioActividad2: modificar.FechaInicioActividadSec ?? '',
            ActividadEconomicaMayorRiesgo: modificar.ActividadEconomicaMayorRiesgo,
            OtrasActividades: modificar.OtrasActividades ?? '',
            Regimen: configuracion.NombreRegimen,
            TipoContribuyente: modificar.TipoContribuyente,
            ContactoAdministrativoNombre: modificar.ContactoAdministrativoNombre,
            ContactoAdministrativoEmail: modificar.ContactoAdministrativoEmail,
            ContactoAdministrativoTelefono: modificar.ContactoAdministrativoTelefono,
            NombreSolicitante: modificar.NombreSolicitante,
            TelefonoSolicitante: modificar.TelefonoSolicitante,
            EmailSolicitante: modificar.EmailSolicitante,
            CargoDeSolicitante: modificar.CargoDeSolicitante,
            ComoNosConoce: modificar.DondeConocioCompuSoluciones,
            Estatus: showRevisar.Estatus,
            Usuario: user.Usuario,
            Comentarios: revisar.Comentarios,
            NumeroCliente: numero
        };

        const config = {
            method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data)
        };

        const res = await enviarPeticion(config, ALTA.AltaIntelisis);

        return res;
    }

    const revisarSolicitud = async () => {

        //SI AUTORIZAN PRIMERO HACEMOS ALTA EN INTELISIS
        if (showRevisar.Estatus === "Autorizar"){

            const resultado = await altaIntelisis();

            //SI EL ALTA FUE EXITOSA
            if (resultado.success === true){

                //REGISTRMOS ANEXOS
                await anexoIntelisis(resultado.data.cliente);

                //ACTUALIZMAOS SOLICITUD
                await actualizarRegistro(resultado.data.cliente);

                //GUARDAMOS LO QUE SE MANDÓ PUDO HABER SIDO EDITADO
                //TAMBIÉN MANDAMOS CORREO DE NOTIFICACIÓN
                await guardarAlta(resultado.data.cliente);

                //GUARDAMOS EL ESTATUS ANTES DE LIMPIAR EL HOOK
                const estatus = showRevisar.Estatus === "Autorizar" ? "Autorizada" : "Rechazada";
                setShowRevisar({Estatus: '', Show: false});
                setShowRevisado({Estatus: estatus, Show: true});
                
            }

            else{
                setShowRevisar({Estatus: '', Show: false});
                setAlert({ msg: `Error al registrar en Intelisis: ${resultado.message}`, severity: 'error', open: true });
            }
        }
        else{ //DE LO CONTRARIO SOLO ACTUALIZAMOS EL REGISTRO
            const res = await actualizarRegistro('');

            if (res.data !== "Error al revisar"){

                //GUARDAMOS EL ESTATUS ANTES DE LIMPIAR EL HOOK
                const estatus = showRevisar.Estatus === "Autorizar" ? "Autorizada" : "Rechazada";
                setShowRevisar({Estatus: '', Show: false});
                setShowRevisado({Estatus: estatus, Show: true});
            }
            else{
                setAlert({ msg: `Error al revisar la solicitud`, severity: 'error', open: true });
            }
        }

    }

    const regresar = () => {
        window.scrollTo(0,0);
        history.push(APP.ALTAS);
    }

    const closeAlert = () => setAlert({ msg: '', severity: 'success', open: false });

    useEffect(()=>{
        const inicio = async () => {
            const list = await llenarListaRegimen();

            const nConfig = obtenerConfiguracion(list, codigos);

            //SI DETECTA UNA CONFIGURACIÓN VERIFICAMOS QUE DEJE SELECCIONA EL RÉGIMEN DE LA LISTA
            if (nConfig !== "Por Definir"){

                const filtro = list.filter(row => row.NombreRegimen === nConfig);

                //VALIDAMOS QUE EL RÉGIMEN LO HAYAN CONFIGURADO BIEN
                if (filtro[0].RegimenIntelisis !== null && filtro[0].Autoretenedor !== null && filtro[0].RetenedorIVA !== null){
                    setConfiguracion(filtro[0]);
                    setRevisar({...revisar, "Regimen": nConfig});

                }
            }

            setLoading(false);
        }
        
        //VALIDAMOS LA SESIÓN
        if (user.Usuario === '' || user.Usuario === null || user.Usuario === undefined){
            history.push(APP.INDEX);
        }
        else{
            inicio();
        }

        return (() => {
            //console.log("");
        });
    }, []);

     return (<>
     <Helmet>
        <title>Detalle Alta</title>
     </Helmet>

     {
        loading ?
        <div className={'container'}>
            <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={100} thickness={2}></CircularProgress>
            </div>
        </div>
        :
        <div className={'container'}>
            <div className="fontNewsGothic">
                <div className="col-sm-12 col-md-12 col-lg-12">

                    {
                        alert.open ? <Alert msg={alert.msg} open={alert.open} severity={alert.severity} segundos={alert.segundos ? alert.segundos : 6} closeAlert={closeAlert}/> : <></>
                    }

                    {/* INICIO MODAL REVISAR*/}
                    <ModalCS show={showRevisar.Show} size='md' title={`${showRevisar.Estatus} Solicitud`} body={
                        <div>
                            <div className="col-sm-12 col-md-12 col-lg-12">     
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: "center"}}>                        
                                    <LabelCS label={`¿Deseas ${showRevisar.Estatus} la solicitud?`}></LabelCS>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: "center"}}>      
                                    <LabelCS style={{fontWeight: 'bold'}} label={modificar.RazonSocial}></LabelCS>
                                </div>                        
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">     
                                <div className="col-sm-6 col-md-6 col-lg-6" style={{textAlign: '-webkit-center'}}>                        
                                    <BotonCS title={showRevisar.Estatus} color={showRevisar.Estatus === "Rechazar" ? "#E00034" : undefined} handleSubmit={revisarSolicitud}></BotonCS>
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6"style={{textAlign: '-webkit-center'}}>                             
                                    <BotonCS color="#7F7F7F" title="Regresar" handleSubmit={cerrarRevisar}></BotonCS>
                                </div>
                            </div>

                        </div>
                    }></ModalCS>
                    {/* FIN MODAL REVISAR*/}

                    {/* INICIO MODAL REVISADO*/}
                    <ModalCS show={showRevisado.Show} size='md' title={`Solicitud ${showRevisado.Estatus}`} body={
                        <div>
                            <div className="col-sm-12 col-md-12 col-lg-12">     
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: "center"}}>                        
                                    <LabelCS label={`Ha sido ${showRevisado.Estatus} la solicitud`}></LabelCS>
                                </div>
                            </div>
                          
                            <div className="col-sm-12 col-md-12 col-lg-12">   
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: "center"}}>      
                                    <LabelCS style={{fontWeight: 'bold'}} label={modificar.RazonSocial}></LabelCS>
                                </div>                        
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 contenedorModal">     
                                <div className="col-sm-12 col-md-12 col-lg-12"style={{textAlign: '-webkit-center'}}>                             
                                    <BotonCS title='Aceptar' handleSubmit={regresarHistorial}></BotonCS>
                                </div>
                            </div>

                        </div>
                    }></ModalCS>
                    {/* FIN MODAL REVISADO*/}

                    {/* INICIO INFORMACIÓN GENERAL DE LA EMPRESA */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Información General de la Empresa</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Razón Social' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={modificar.RazonSocial} onChange={handleModificar("RazonSocial")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='NIT' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <TextFieldCS name="" disabled={true} value={modificar.NIT} onChange={handleModificar("NIT")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-1 col-md-1 col-lg-1">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='DV' />   
                        </div>    
                        <div className="col-sm-1 col-md-1 col-lg-1">
                            <TextFieldCS name="" disabled={true} value={modificar.DV?? ''} onChange={handleModificar("DV")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Dirección' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.Direccion === null || modificar.Direccion === undefined || modificar.Direccion === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.Direccion} onChange={handleModificar("Direccion")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Código Postal' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.CP === null || modificar.CP === undefined || modificar.CP === "" || modificar.CP.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" type="number" value={modificar.CP} onChange={handleModificar("CP")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.Telefono === null || modificar.Telefono === undefined || modificar.Telefono === "" || modificar.Telefono.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" type="number" value={modificar.Telefono} onChange={handleModificar("Telefono")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Municipio' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.Municipio === null || modificar.Municipio === undefined || modificar.Municipio === "" || modificar.Municipio.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.Municipio} onChange={handleModificar("Municipio")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Departamento' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.Departamento === null || modificar.Departamento === undefined || modificar.Departamento === "" || modificar.Departamento.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.Departamento} onChange={handleModificar("Departamento")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Representante Legal' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.RepresentanteLegal === null || modificar.RepresentanteLegal === undefined || modificar.RepresentanteLegal === "" || modificar.RepresentanteLegal.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.RepresentanteLegal} onChange={handleModificar("RepresentanteLegal")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Documento' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <DropDownListCS items={[{value: 'Selecciona una opción'}, {value: 'Cédula de Ciudadanía'}, {value: 'Cédula de Extranjería'}, {value: 'Pasaporte'}]} default={modificar.TipoDocumento} onChange={handleModificar("TipoDocumento")}></DropDownListCS>
                            {/* <TextFieldCS name="" value={modificar.TipoDocumento} onChange={handleModificar("TipoDocumento")}></TextFieldCS> */}
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Número Identificación' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.NumeroIdentificacion === null || modificar.NumeroIdentificacion === undefined || modificar.NumeroIdentificacion === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" type="number" value={modificar.NumeroIdentificacion} onChange={handleModificar("NumeroIdentificacion")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Primaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={modificar.CodigoCIIUActividadPrimaria} onChange={handleModificar("CodigoCIIUActividadPrimaria")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Inicio Actividad Primaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={formatDate(modificar.FechaInicioActividad)} onChange={handleModificar("FechaInicioActividad")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '80px'}}>
                        <div className="col-sm-2 col-md-2 col-lg-2" style={{display: 'flex', height: '80px', alignItems: 'center'}}>
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Descripción Actividad Primaria' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10" style={{display: 'flex'}}>
                            {
                                modificar.ActividadPrincipalDes === null || modificar.ActividadPrincipalDes === undefined || modificar.ActividadPrincipalDes === "" || modificar.ActividadPrincipalDes.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.ActividadPrincipalDes} multiline maxRows={3} onChange={handleModificar("ActividadPrincipalDes")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Secundaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={modificar.CodigoCIIUActividadSecundaria} onChange={handleModificar("CodigoCIIUActividadSecundaria")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Inicio Actividad Secundaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={formatDate(modificar.FechaInicioActividadSec)} onChange={handleModificar("FechaInicioActividad")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '80px'}}>
                        <div className="col-sm-2 col-md-2 col-lg-2" style={{display: 'flex', height: '80px', alignItems: 'center'}}>
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Descripción Actividad Secundaria' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10" style={{display: 'flex'}}>
                            {
                                (modificar.CodigoCIIUActividadSecundaria !== "" && modificar.FechaInicioActividadSec !== "" && modificar.FechaInicioActividadSec !== null) &&
                                (modificar.ActividadSecundariaDes === null || modificar.ActividadSecundariaDes === undefined || modificar.ActividadSecundariaDes === "" || modificar.ActividadSecundariaDes.trim() === "") ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.ActividadSecundariaDes} disabled={segundaDescripcion} multiline maxRows={3} onChange={handleModificar("ActividadSecundariaDes")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Mayor Riesgo' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.ActividadEconomicaMayorRiesgo === null || modificar.ActividadEconomicaMayorRiesgo === undefined || modificar.ActividadEconomicaMayorRiesgo === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" type="number" value={modificar.ActividadEconomicaMayorRiesgo} onChange={handleModificar("ActividadEconomicaMayorRiesgo")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Otras Actividades' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" value={modificar.OtrasActividades} onChange={handleModificar("OtrasActividades")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Régimen' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={modificar.TipoRegimen} onChange={handleModificar("TipoRegimen")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Contribuyente' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={modificar.TipoContribuyente} onChange={handleModificar("TipoContribuyente")}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN INFORMACIÓN GENERAL DE LA EMPRESA */}

                    {/* INICIO DATOS DEL CONTACTO COMERCIAL */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Contacto Comercial</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Nombre' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.NombreSolicitante === null || modificar.NombreSolicitante === undefined || modificar.NombreSolicitante === "" || modificar.NombreSolicitante.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.NombreSolicitante ?? ''} onChange={handleModificar("NombreSolicitante")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Cargo' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.CargoDeSolicitante === null || modificar.CargoDeSolicitante === undefined || modificar.CargoDeSolicitante === "" || modificar.CargoDeSolicitante.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.CargoDeSolicitante ?? ''} onChange={handleModificar("CargoDeSolicitante")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Email' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.EmailSolicitante === null || modificar.EmailSolicitante === undefined || modificar.EmailSolicitante === "" || modificar.EmailSolicitante.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.EmailSolicitante ?? ''} onChange={handleModificar("EmailSolicitante")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.TelefonoSolicitante === null || modificar.TelefonoSolicitante === undefined || modificar.TelefonoSolicitante === "" || modificar.TelefonoSolicitante.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" type="number" value={modificar.TelefonoSolicitante ?? ''} onChange={handleModificar("TelefonoSolicitante")}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN DATOS DEL CONTACTO COMERCIAL */}

                    {/* INICIO CONTACTO ADMINISTRATIVO */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Contacto Administrativo</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Nombre' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.ContactoAdministrativoNombre === null || modificar.ContactoAdministrativoNombre === undefined || modificar.ContactoAdministrativoNombre === "" || modificar.ContactoAdministrativoNombre.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.ContactoAdministrativoNombre ?? ''} onChange={handleModificar("ContactoAdministrativoNombre")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Email' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.ContactoAdministrativoEmail === null || modificar.ContactoAdministrativoEmail === undefined || modificar.ContactoAdministrativoEmail === "" || modificar.ContactoAdministrativoEmail.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.ContactoAdministrativoEmail ?? ''} onChange={handleModificar("ContactoAdministrativoEmail")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{display: 'flex'}}>
                            {
                                modificar.ContactoAdministrativoTelefono === null || modificar.ContactoAdministrativoTelefono === undefined || modificar.ContactoAdministrativoTelefono === "" || modificar.ContactoAdministrativoTelefono.trim() === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" type="number" value={modificar.ContactoAdministrativoTelefono ?? ''} onChange={handleModificar("ContactoAdministrativoTelefono")}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN CONTACTO ADMINISTRATIVO */}

                    {/* INICIO SE ENTERÓ MEDIANTE */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Cómo Nos Conoce</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Cómo se enteró de CompuSoluciones' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10" style={{display: 'flex'}}>
                            {
                                modificar.DondeConocioCompuSoluciones === null || modificar.DondeConocioCompuSoluciones === undefined || modificar.DondeConocioCompuSoluciones === "" ?
                                <label style={{color: 'red'}}>*</label>
                                : <></>
                            }
                            <TextFieldCS name="" value={modificar.DondeConocioCompuSoluciones ?? ''} onChange={handleModificar("DondeConocioCompuSoluciones")}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN SE ENTERÓ MEDIANTE */}

                    {/* INICIO DOCUMENTOS */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Documentos</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Registro Único Tributario' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                                modificar.Rut !== null && modificar.Rut !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('rut')}></BotonCS>
                            :<></>
                        }
                        </div>  
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Certificado Cámara Comercio' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            {
                                modificar.CertificadoCamaracomer !== null && modificar.CertificadoCamaraComer !== '' ?
                                <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('ccc')}></BotonCS>
                                : <></>
                            }
                        </div>                            
                    </div>
                                      
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Identificación Representante Legal' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                            modificar.IdentificacionRepLegal !== null && modificar.IdentificacionRepLegal !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('irl')}></BotonCS>
                            : <></>
                        }
                        </div>   
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Referencia Comercial 1' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                            modificar.CartaReferencia1 !== null && modificar.CartaReferencia1 !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('rc1')}></BotonCS>
                            : <></>
                        }
                        </div>                         
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">                          
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Referencia Comercial 2' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                            modificar.CartaReferencia2 !== null && modificar.CartaReferencia2 !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('rc2')}></BotonCS>
                            : <></>
                        }
                        </div>   
                        <div className="col-sm-4 col-md-4 col-lg-4">
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        </div>   
                    </div>  
                    <br />
                    <br />
                    {/* FIN DOCUMENTOS */}

                    {/* INICIO REVISAR SOLICITUD */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Revisar Solicitud</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Comentarios' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" value={revisar.Comentarios ?? ''} placeholder='Escribe un comentario...' multiline maxRows={3} onChange={handleRevisar("Comentarios")}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Régimen' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <DropDownListCS items={listaRegimen} valor='NombreRegimen' default={revisar.Regimen ?? ''} onChange={handleRevisar("Regimen")}></DropDownListCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Configuración Régimen' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" value={configSel} disabled={true}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Responsabilidades RUT' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" value={`Códigos ${codigos} - Régimen detectado: ${config}`} disabled={true}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN REVISAR SOLICITUD */}

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{textAlign: '-webkit-center'}}>
                            <BotonCS title='Autorizar' handleSubmit={() => clickRevisar("Autorizar")}></BotonCS>
                        </div>      
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{textAlign: '-webkit-center'}}>
                            <BotonCS color='#E00034' title='Rechazar' handleSubmit={() => clickRevisar("Rechazar")}></BotonCS>
                        </div>      
                        <div className="col-sm-4 col-md-4 col-lg-4" style={{textAlign: '-webkit-center'}}>
                            <BotonCS color='#7F7F7F' title='Regresar' handleSubmit={regresar}></BotonCS>
                        </div>                  
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>

     }
     </>)
}

export default React.memo(withRouter(DetalleAlta));